import { useTranslation } from 'react-i18next';
import { TaskData } from '../../../models';

export function FeedbackCard({ taskData }: { taskData: TaskData }) {
  const [t] = useTranslation('chatroom');
  const { question, answer, type, feedback } = taskData;

  let element = (
    <div className="w-full flex flex-col p-3 gap-3 bg-gray-300">
      <span>Q: {question}</span>
      <span className="font-semibold text-xl">A: {answer}</span>
    </div>
  );

  if (type === 'image') {
    element = (
      <div className="h-[40vh] w-full">
        <img alt="pic" src={answer} className="object-contain h-full w-full" />
      </div>
    );
  }

  return (
    <div className="flex flex-col w-full bg-white">
      {element}
      <div className="bg-manage-primary w-full p-3">
        <div className="flex flex-col bg-white px-3 py-1 rounded-lg">
          <span className="font-semibold">
            {t('activity_record_feedback_title', '組長小叮嚀：')}
          </span>
          <span>{feedback}</span>
        </div>
      </div>
    </div>
  );
}
